  import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
  import { ChartOptions, ChartDataSets } from 'chart.js';

  @Component({
    selector: 'kt-doughnut-chart',
    templateUrl: './doughnut-chart.component.html',
    styleUrls: ['./doughnut-chart.component.css']
  })
  export class DoughnutChartComponent implements OnInit {

    @Input() chartLabels: string[] = []; // Dynamic labels for the chart
    @Input() chartData: number[] = [];  // Dynamic data for the chart

    public doughnutChartType: 'doughnut' = 'doughnut';

    // Data for Doughnut Chart
    public doughnutChartData: ChartDataSets[] = [
      {
        data: [],
        backgroundColor: [],
        hoverBackgroundColor: [],
      },
    ];

    // Options for Doughnut Chart
    public doughnutChartOptions: ChartOptions = {
      maintainAspectRatio: false,
        legend: {
          position: 'bottom',
        },
    };

    private readonly defaultColors = [
      '#FF7360', '#6FC8CE', '#F7B7A3', '#D3B8E5', '#FFD54F', '#90CAF9',
    ];
    private readonly defaultHoverColors = [
      '#FF6360', '#5AC9CE', '#E7A7A3', '#C3A8E5', '#FFC34F', '#80BAF9',
    ];

    constructor() {}

    ngOnInit(): void {}

    ngOnChanges(changes: SimpleChanges): void {
      if (changes['chartLabels'] || changes['chartData']) {
        // Update labels and data dynamically
        this.updateChart();
      }
    }

    // private updateChart(): void {
    //   // Assign colors dynamically based on data length
    //   const backgroundColors = (this.chartData && this.chartData.map) ? this.chartData.map(
    //     (_, index) => this.defaultColors[index % this.defaultColors.length]
    //   ) :[] ;
    //   const hoverBackgroundColors = (this.chartData && this.chartData.map) ? this.chartData.map(
    //     (_, index) => this.defaultHoverColors[index % this.defaultHoverColors.length]
    //   ) : [];

    //   // Update chart data
    //   this.doughnutChartData = {
    //     labels: this.chartLabels,
    //     datasets: [
    //       {
    //         data: this.chartData,
    //         backgroundColor: backgroundColors,
    //         hoverBackgroundColor: hoverBackgroundColors,
    //       },
    //     ],
    //   };
    // }
    private updateChart(): void {
      if (!Array.isArray(this.chartData) || this.chartData.length === 0) return;
  
      const backgroundColors = this.chartData.map((_, index) => this.defaultColors[index % this.defaultColors.length]);
      const hoverBackgroundColors = this.chartData.map((_, index) => this.defaultHoverColors[index % this.defaultHoverColors.length]);
  
      this.doughnutChartData = [
        {
          data: this.chartData,
          backgroundColor: backgroundColors,
          hoverBackgroundColor: hoverBackgroundColors,
        },
      ];
    }

  }
